import React, { useEffect } from "react";
import {
  Grid2,
  Typography,
  TextField,
  Button,
  Box,
} from "@mui/material";
import SignUpBg from "../../../Assets/Images/Signup_web.png";
import styles from "./SignUpPhone.module.css"; // Import the CSS module
import { useDispatch, useSelector } from 'react-redux';
import { checkAndNavigate, generateMobileOtp, resetToInitial, setbankData, setDigiData, setNomineData, setpersonalData, setuserData, setPlanData, setPanData, fetchTokenData,updateTokenData, setRetakeAuth, setRetakeTokenToTrue, setRetakeTokenToFalse, setRetakeError, ReloginDirectStep, setSource } from '../../../Redux/usersSlice';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useState } from "react";
import Logo from '../../../Assets/Images/logo.svg';
import collab from '../../../Assets/Images/collab1.svg';
import validator from 'validator';
import CircularProgress from '@mui/material/CircularProgress';

const SignUpPhone = () => {

  // Inside your component
  const { loading, error, userData, retakeToken,source  } = useSelector(state => state.user);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setloader] = useState(false)
  const [refCodeFromUrl,setRefCodeFromUrl]=useState("")
  
  const [searchParams] = useSearchParams();
  
  const [clientError, setClientError] = useState("")
  const [mobile, setMobileInput] = useState(userData?.mobile || "");

  // Validation function
  const runClientValidation = () => {
    const isValid = validator.isMobilePhone(String(mobile), 'en-IN');

    if (!isValid) {
      setClientError("Please enter a valid mobile number");
      return false;
    }
    setClientError(""); // Clear previous errors
    return true;
  };



 



  useEffect(() => {

    const crm=searchParams.get("resume");
    const token = searchParams.get("token");
    console.log("params", token)
    const fetchData = async () => {
    
      const mobile = searchParams.get("mobilenofromhome");
      const refCode= searchParams.get("refCode") || searchParams.get("refcode")
      const source1 = searchParams.get("source")
      const isCfg = refCode === "CFG" || localStorage.getItem("refCode") === "CFG";
      if (!(source1 === "cosmos" && isCfg)) {
        const baseUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, baseUrl);
      }
    
      console.log("✅✅",source1)
      source1 == "cosmos" ? localStorage.setItem("source", source1) : localStorage.setItem("source", "")
      if(refCode){
        setRefCodeFromUrl(refCode)
        localStorage.setItem("refCode",refCode)
      }
      console.log(mobile);
      setloader(false); // Reset loader when component mounts

      if (!mobile) return; // Early exit if no mobile number   

      try {
        setloader(true); // Start loading
       const response = await dispatch(generateMobileOtp({mobile,referral_code:refCodeFromUrl})).unwrap();
        // Check if user exists in response
        if (response.data?.user) {

          dispatch(setuserData(response.data?.user))
          if (response.data?.personal) {
            dispatch(setpersonalData(response.data?.personal))
          }
          if (response.data?.bank) {
            dispatch(setbankData(response.data?.bank))
          }
          if (response.data?.digilocker) {
            dispatch(setDigiData(response.data?.digilocker))
          }
          if (response.data?.nominee) {
            dispatch(setNomineData(response.data?.nominee))
          }
          if (response.data?.plan) {
            dispatch(setPlanData(response.data?.plan))
          }
          if (response.data?.pan) {
            dispatch(setPanData(response.data?.pan))
          }
          const { payload } = await dispatch(checkAndNavigate());

          console.log(payload.allComplete)

          if (payload.allComplete) {
            // All required steps completed - go to products
            console.log("Navigating to dis page...")
            navigate("/dis");
          } else {
            const isEmailVerified = response.data.user.steps?.["Email Verify"]?.status;
            navigate(isEmailVerified ? '/signupcongrats' : '/signupemail');
          }
        } else {
          // New user - go to OTP
          if (response?.data?.success) {
            navigate('/signupphotp');
            //for new user
            dispatch(setuserData({ mobile: mobile }))
          } else if (response.data.message === "Please provide a valid mobile number") {
            setClientError("Please provide a valid mobile number")
          }
        }
      } catch (error) {
        console.error('OTP send failed:', error);
      } finally {
        setloader(false); // Stop loading (runs in both success and error cases)
      }
    };


    if (token) {
      retakeGenOtp(token)
    } else if (crm) {
      ReloginFromTODirectStep(crm)
    }
    else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "kyc_step_viewed",
        step_name: "mobile_page_viewed",
        page_path: window.location.pathname
      });
      dispatch(setRetakeTokenToFalse())
      fetchData();
    }

    

    
  }, [searchParams, dispatch, navigate]);

  // reset everything
  useEffect(() => {
    const source = localStorage.getItem("source") 
    dispatch(resetToInitial(source))
  }, [])

  const ReloginFromTODirectStep = async (crm) => {
    const mobile = crm
    if (!mobile) return;

    try {
      setloader(true);
      const response = await dispatch(ReloginDirectStep({ mobile })).unwrap();
      console.log("responsefromcrm",response)
      if (response.data?.user) {

        dispatch(setuserData(response.data?.user))
        if (response.data?.personal) {
          dispatch(setpersonalData(response.data?.personal))
        }
        if (response.data?.bank) {
          dispatch(setbankData(response.data?.bank))
        }
        if (response.data?.digilocker) {
          dispatch(setDigiData(response.data?.digilocker))
        }
        if (response.data?.nominee) {
          dispatch(setNomineData(response.data?.nominee))
        }
        if (response.data?.plan) {
          dispatch(setPlanData(response.data?.plan))
        }
        if (response.data?.pan) {
          dispatch(setPanData(response.data?.pan))
        }
        const { payload } = await dispatch(checkAndNavigate());

        console.log(payload.allComplete)

        if (payload.allComplete) {
          // All required steps completed - go to products
          console.log("Navigating to dis page...")
          navigate("/dis");
        } else {
          const isEmailVerified = response.data.user.steps?.["Email Verify"]?.status;
          navigate(isEmailVerified ? '/signupcongrats' : '/signupemail');
        }
      } else {
        // New user - go to OTP
        if (response?.data?.success) {
          navigate('/signupphotp');
          //for new user
          dispatch(setuserData({ mobile: mobile }))
        } else if (response.data.message === "Please provide a valid mobile number") {
          setClientError("Please provide a valid mobile number")
        }
      }

    } catch (error) {
      console.error('OTP send failed:', error);
    } finally {
      setloader(false); // Stop loading (runs in both success and error cases)
    }
  };

  const retakeGenOtp = async (token) => {
    try {
      dispatch(setRetakeTokenToTrue())
      const response = await dispatch(fetchTokenData({ token })).unwrap();
      console.log("retakegenOtp", response)
      if (response?.data?.data?.success) {
        const mobile = response?.data?.data?.mobile
        try {
          const otpResponse = await dispatch(generateMobileOtp({ mobile, referral_code: "" })).unwrap();
          console.log("OTP Response", otpResponse?.data)

          if (otpResponse?.data?.success) {

            try{
               const response = await dispatch(updateTokenData({ token })).unwrap();
            }catch(error){
                console.error('Something went wrong while updating token data.', error);
            }
            let res = {
              email: response?.data?.data?.email,
              mobile: response?.data?.data?.mobile,
              step: response?.data?.data?.step
            }
            dispatch(setRetakeAuth(res))
            navigate("/retake-otp")
          }else{
            dispatch(setRetakeError(response?.data?.message || "Something went wrong.Please try again later"))
            navigate("/retake-otp")
          }
        } catch (error) {
          dispatch(setRetakeError("Something went wrong.Kindly contact our Support team at:support@tradeboss.co"))
          console.error('Retake OTP send failed:', error);
        }

      }else{
        dispatch(setRetakeError(response?.data?.data?.message || "Something went wrong.Kindly contact our Support team at:support@tradeboss.co"))
        navigate("/retake-otp")
      }
    } catch (error) {
      dispatch(setRetakeError("Something went wrong.Kindly contact our Support team at:support@tradeboss.co"))
      navigate("/retake-otp")
      console.error('Something went wrong while fetch data from data retake token', error);
    }
  }



  // Redirect if already verified
  useEffect(() => {
    if (userData?.steps?.["Email Verify"]?.status) {
      navigate('/signupcongrats');
    } else if (userData?.steps) { // Mobile verified but no email
      navigate('/signupemail');
    }
  }, [userData, navigate]);





  const handleSendOtp = async (e) => {
    e.preventDefault();
    // if (!mobile) return;
    // Stop if validation fails
    if (!runClientValidation()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "mobile_entered",
      page_path: window.location.pathname
    });

    try {
      const response = await dispatch(generateMobileOtp({mobile,referral_code:refCodeFromUrl})).unwrap();

      // Check if user exists in response
      if (response.data?.user) {

        dispatch(setuserData(response.data?.user))
        if (response.data?.personal) {
          dispatch(setpersonalData(response.data?.personal))
        }
        if (response.data?.bank) {
          dispatch(setbankData(response.data?.bank))
        }
        if (response.data?.digilocker) {
          dispatch(setDigiData(response.data?.digilocker))
        }
        if (response.data?.nominee) {
          dispatch(setNomineData(response.data?.nominee))
        }
        if(response.data?.plan){
          dispatch(setPlanData(response.data?.plan))
        }
        if (response.data?.pan) {
          dispatch(setPanData(response.data?.pan))
        }
        const { payload } = await dispatch(checkAndNavigate());
        console.log(payload.allComplete)

        if (payload.allComplete) {
          // All required steps completed - go to products
          console.log("Navigating to dis page...")
          navigate("/dis");
        } else {
          const isEmailVerified = response.data.user.steps?.["Email Verify"]?.status;
          navigate(isEmailVerified ? '/signupcongrats' : '/signupemail');
        }
      } else {
        // New user - go to OTP
        if (response.data?.success) {
          navigate('/signupphotp');
          //for new user
          dispatch(setuserData({ mobile: mobile }))
        } else if (response.data.message === "Please provide a valid mobile number") {
          setClientError("Please provide a valid mobile number")
        }
      }
    } catch (error) {
      console.error('OTP send failed:', error);
      setClientError(error?.data?.data?.message)
    }
  };

  if (loader) {
    return <h1 style={{ alignItems: "center", "justifyContent": "center" }}>Loading...</h1>
  }

  const handleKeyDown = (e) => {
  if (e.key === 'Enter') {
    handleSendOtp(e);
  }
};

  return (
    <main>

      {
        retakeToken ? <Grid2 sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundImage: `url(${SignUpBg})`, 
          backgroundSize: "cover", 
          backgroundPosition: "center", 
          backgroundRepeat: "no-repeat",
        }}>
          <CircularProgress />
        </Grid2> 
        :
         <>
          <Grid2
          sx={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundImage: `url(${SignUpBg})`, 
            backgroundSize: "cover", 
            backgroundPosition: "center", 
            backgroundRepeat: "no-repeat", 
            "@media (max-width:600px)": {
              justifyContent: "start"
            }
          }}
        >
          <Box
            sx={{
              textAlign: "center",
              backdropFilter: "blur(10px)",
              padding: "0px 40px 30px 40px",
              borderRadius: "12px",
              "@media (max-width:600px)": {
                padding: "30px 10px 0px 10px ",
              }
            }}
          >
            <img
              src={source == "cosmos" ? collab :Logo}
              alt="Logo"
              className={source == "cosmos" ? styles.twologo : styles.nav_logo}
            />
            {
                  source == "cosmos" && 
                  <Typography className={styles.txt}>
                    Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
                  </Typography>
            }
             
            {/* Heading */}
            <Typography className={styles.heading}>
              Enter Your Phone number
            </Typography>

            {/* Subheading */}
            <Typography className={styles.subHeading}>
              To Personalize your Experience
            </Typography>

            {/* Email Input Field */}
            {/* <TextField
            fullWidth
            variant="outlined"
            placeholder="Enter your mobile number"
            sx={{
              backgroundColor: "white",
              borderRadius: "39px",
              "& input": { textAlign: "center" },
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderRadius: "25px" },
              },
              maxWidth: "400px",
            }}
            onChange={(e) => setMobileInput(e.target.value.trim())}
          /> */}
            <form autoComplete="off">
              <input type="text" name="fakeuser" autoComplete="username" style={{ display: "none" }} />
              <input type="password" name="fakepass" autoComplete="new-password" style={{ display: "none" }} />
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Enter your mobile number"
                value={mobile}
                sx={{
                  backgroundColor: "white",
                  borderRadius: "39px",
                  borderColor: "#000000",
                  "& input": {
                    textAlign: "center",
                    fontSize: "24px",
                    padding: "11px 12px",
                    "&::placeholder": {
                      fontSize: "20px",
                      color: "#000000",
                      "@media (max-width: 550px)": {
                        fontSize: "18px",

                      },
                      "@media (max-width: 550px)": {
                        fontSize: "18px",

                      },
                    },
                    "@media (max-width: 550px)": {
                      fontSize: "18px",
                      paddingTop: "13px"
                    },
                    "@media (max-width: 550px)": {
                      fontSize: "18px",
                      paddingTop: "12px"
                    },
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderRadius: "30px",
                      borderColor: "#ABABAB",
                    },
                    "&:hover fieldset": {
                      borderColor: "#ABABAB !important", // stop hover change
                      borderWidth: "0.5px"
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#ABABAB !important", // stop focus change
                      borderWidth: "0.5px"
                    },
                    "@media (max-width: 550px)": {
                      width: "302px",
                      height: "54px"
                    },
                    "@media (max-width: 420px)": {
                      width: "270px",
                      height: "54px"
                    },

                  },
                  width: "400px",
                  "@media (max-width: 550px)": {
                    width: "300px",
                    height: "50px"
                  },
                  "@media (max-width: 420px)": {
                    width: "270px",
                    height: "50px"
                  },
                  "& .MuiInputBase-input": {

                    letterSpacing: "5px !important",

                  },
                  "& ::placeholder": {
                    letterSpacing: "normal", // Keep placeholder spacing normal
                  },
                }}
                onChange={(e) => {
                  // Filter out all non-digit characters
                  const filteredValue = e.target.value.replace(/[^\d]/g, "").trim();
                  setMobileInput(filteredValue);
                }}
                onKeyDown={handleKeyDown}  // Add Enter key functionality
                onKeyDownCapture={(e) => {
                  // Allow Backspace, Delete, Arrow keys, Tab, etc.
                  if (
                    e.key === " " || // Prevent spacebar
                    (/^[a-zA-Z]$/.test(e.key) && !e.ctrlKey && !e.metaKey) // Prevent alphabets unless Ctrl or Meta key is pressed
                  ) {
                    e.preventDefault();
                  }
                }}
                inputProps={{
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                  onPaste: (e) => {
                    e.preventDefault();
                    const pastedText = e.clipboardData.getData("text/plain");
                    const numbersOnly = pastedText.replace(/[^\d]/g, "").trim();
                    document.execCommand("insertText", false, numbersOnly);
                  },
                }}
              />
            </form>


            {clientError && <Typography color="error">{clientError}</Typography>}

            {/* Next Button */}
            <Button
              fullWidth
              variant="contained"
              sx={{
                marginTop: "20px",
                backgroundColor: "#F3D45E",
                color: "#000",
                fontFamily: "Inter700",
                borderRadius: "25px",
                padding: "12px",
                textTransform: "capitalize",
                "&:hover": { backgroundColor: "#FBC02D" },
                maxWidth: "400px",
                boxShadow: "none",
                "@media (max-width: 550px)": {
                  width: "300px",
                  height: "45px"
                },
                "@media (max-width: 420px)": {
                  width: "270px",
                  height: "45px"
                },
              }}
              onClick={handleSendOtp}
            >
              {loading ? 'Sending...' : 'Next'}
            </Button>

          </Box>
        </Grid2>
      </>
      
    }
     
    </main>
  );
};

export default SignUpPhone;
